import React, { memo, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { Box } from '@mui/material';
import FormGenerator from '@sharedCR/common/formGenerator';
import { FormNames } from 'app/services/autoLockForms/autoLockForms.constants';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import { getCustomFieldsAction } from 'store/pricing/actions';
import { selectPricingCustomFields } from 'store/pricing/selectors';

import { defaultForm, pagesPropTypes } from '../MainContent.constants';
import { ContentHeadline } from '../sharedComponents';

import { getOBCustomFieldsConfig } from './OBCustomFields.config';
import { getConfigFields } from './OBCustomFields.utils';

const OBCustomFields = ({
  changedFields,
  isLoading,
  isSaving,
  form = defaultForm,
  validationErrors,
  validateField,
  handleChange,
  setEntityConfig,
  setInForm,
  className,
  staticValidateField,
  pendingChanges,
  disabledPendingChangesHighlight,
  setIsLoading,
}) => {
  const dispatch = useDispatch();

  const { applicationId } = useParams();

  const customFields = useSelector(selectPricingCustomFields);

  useEffectSafeStrictMode(() => {
    setIsLoading(true);

    dispatch(getCustomFieldsAction({ applicationId })).finally(() => setIsLoading(false));
  }, [dispatch, applicationId, setIsLoading]);

  const obCustomFieldsConfig = useMemo(() => {
    const configFields = getConfigFields({ customFields });
    const config = getOBCustomFieldsConfig(configFields);

    return config;
  }, [customFields]);

  useEffect(() => {
    setEntityConfig({
      groups: [...obCustomFieldsConfig.groups],
    });
  }, [obCustomFieldsConfig, setEntityConfig]);

  return (
    <Box className={className}>
      <ContentHeadline title="OB Custom Fields" />

      <Box>
        <FormGenerator
          isNestedForm
          changedFields={changedFields}
          config={obCustomFieldsConfig}
          disabledPendingChangesHighlight={disabledPendingChangesHighlight}
          form={form}
          formName={FormNames.DOCUMENT_VERIFICATION_TYPES}
          handleChange={handleChange}
          isLoading={isSaving || isLoading}
          numberOfColumns={4}
          pendingChanges={pendingChanges}
          setInForm={setInForm}
          staticValidateField={staticValidateField}
          validateField={validateField}
          validationErrors={validationErrors}
        />
      </Box>
    </Box>
  );
};

OBCustomFields.propTypes = pagesPropTypes;

export default memo(OBCustomFields);
